module.exports = __webpack_public_path__ + "static/img/wbz805bb.5acf6d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wbz805bb.jpg
// module id = iS6l
// module chunks = 0